export const logUserOut = () => {};

export const UserCacheUpdates = {
  logUserOut,
};
